
import { supabase } from '../../supabase';
import { OSStat } from '../types';
import { AuthFilter } from '@/components/analytics/AuthFilterButtons';

/**
 * Get OS distribution statistics
 */
export const getOSStats = async (
  startDate: Date, 
  endDate: Date, 
  authFilter: AuthFilter = 'all'
): Promise<OSStat[]> => {
  const { data, error } = await supabase.rpc('get_os_stats_aggregated', {
    start_date: startDate.toISOString(),
    end_date: endDate.toISOString(),
    auth_filter: authFilter
  });
  
  if (error) {
    console.error('Error fetching OS stats:', error);
    throw error;
  }
  
  return (data || []).map(item => ({
    os: item.os,
    count: Number(item.count)
  }));
};
